<template>
    <div class="idle-flip-book-details">
        <!-- 路由 -->
        <div class="router-container">
            <router-link class="router-item" to="/read/readIndex">
                <span>首页</span>
            </router-link>/
            <router-link class="router-item" to="/read/idleFlipBook">
                <span>闲翻书</span>
            </router-link>/
            <div>
                <span>{{detail.title}}</span>
            </div>
        </div>

        <div class="main-content">
            <!-- 问题投票区域 -->
            <div class="question-section">
                <div class="question-header">
                    <h1 class="question-title">{{detail.title}}</h1>
                    <div class="question-meta">
                        <span class="issue-info">闲翻书·第{{ detail.version }}期</span>
                        <span class="participants">{{detail.countA + detail.countB || '0'}}人参与</span>
                    </div>
                </div>
                <div class="vote-results"  v-if="detail.voteStatus">
                    <div class="result-item" v-for="(field, fieldIndex) in ['A', 'B']" :key="fieldIndex"> 
                        <div class="result-item-left">
                            <el-row :gutter="24" class="result-item-info">
                                <el-col :span="12">
                                    <div class="result-label">{{ detail[`field${field}`] }}</div>
                                </el-col>
                                <el-col :span="12">
                                    <div class="result-votes">{{ detail[`count${field}`] }}票</div>
                                </el-col>
                            </el-row>
                            <div class="result-item-icon">{{parseFloat((detail[`Ratio${field}`] || '0'))}}%</div>
                        </div>
                        <div class="result-item-right">
                            <div class="result-bar">
                                <el-progress :percentage="parseFloat((detail[`Ratio${field}`] || '0').replace('%', ''))"  :color="field === 'A' ? '#747FEB' : '#F4705E'" :show-text="false" :stroke-width="10"></el-progress>
                            </div>
                        </div>
                        
                    </div>
                </div>
                <div  class="vote-buttons" v-else>
                    <button class="vote-btn vote-btn-purple" @click="vote(detail,'A')">{{detail.fieldA}}</button>
                    <button class="vote-btn vote-btn-red" @click="vote(detail,'B')">{{detail.fieldB}}</button>
                </div>

               
            </div>

            <!-- 推荐书单导航 -->
            <div class="recommendation-section">
                <h2 class="section-title">推荐书单</h2>
                <div class="content-tabs">
                    <button class="tab-btn" :class="TabCur == index ? 'tab-active' : ''" v-for="(item,index) in tabList" :key="index" @click="tabChange(item.key, index)">{{item.name}}</button>
                </div>
            </div>

            <!-- 书籍网格 -->
            <div class="books-grid">
                <div class="book-item" v-for="(book, index) in bookList" :key="index"  @click="setupBackRouterPath(book)">
                    <div class="book-cover">
                        <img v-if="book.indexType == 'Book' || book.indexType == null" :src="prefix + 'ui/draftBook/getCover?multimediaID=' + book.source.logoID" alt="book cover" class="image-placeholder"  @error="handleError">
                        <img v-else :src="book.source.imgUrlCompressed" alt="" @error="handleError" >
                    </div>
                    <div class="book-info">
                        <h3 class="book-title">{{ book.source.title }}</h3>
                        <p class="book-author">{{ book.source.author }}</p>
                    </div>
                </div>
                
                <!-- 无更多数据提示 -->
                <div v-if="noMore && bookList&& bookList.length > 0" class="no-more">
                    已加载全部数据
                </div>
                <div v-if="bookList.length === 0" class="no-data">
                    暂无数据
                </div>
            </div>
            <loading-view v-if="loading" />
        </div>
    </div>
</template>

<script>
import api from '@/api/index.js';
export default {
    name: 'idleFlipbookDetails',
    data() {
        return {
            detail: {},
            prefix: this.prefix,
            tabList:[{name: '电子书', key: 'eBook'}, {name: '有声书', key: 'audioBook'}, {name: '课程', key: 'course'}],
            TabCur: 0,
            params: {
                type: 'eBook',
                pageSize: 12,
                pageIndex: 0
            },
            total: 0,
            bookList: [],
            scrollContainer: null,  // 父组件的滚动容器DOM
            scrollDebounce: null,    // 防抖计时器
            finished: false,
            loading: false,
            noMore: false, // 是否无更多数据
            id:this.$route.query.ID
        }
    },
    props: {
        parentScrollRef: {  // 父组件传递的滚动容器ref名称
            type: String,
            default: 'main'
        }
    },
    mounted() {
        // 1. 获取父组件的滚动容器（关键步骤）
        this.getParentScrollContainer();
        this.scrollParentToTop()
    },
    created(){
        this.user_token = localStorage.getItem("user_token")
        this.login()
        
    },
    methods: {
        scrollParentToTop() {
            // 1. 获取父组件的滚动容器DOM
            const parentScrollContainer = this.$parent.$refs[this.parentScrollRef];
            if (!parentScrollContainer) {
                console.error('未找到父组件滚动容器，请检查ref是否正确');
                return;
            }
            parentScrollContainer.scrollTop = 0;
        },
        async login() {
            this.id = this.$route.query.ID
            this.getDetail(this.id)
            this.getDetailBook(this.id)
        },
        // 投票
        async getDetail(id) {
            const res = await api.fetchLeisureDetail(id)
            if(res.status) {
                console.log("this.detail",this.detail)
                this.detail = res.data.data
            }
        },
        tabChange(key,index) {
            this.TabCur = index;
            this.params.type = key
            this.params.pageIndex = 0
            this.noMore = false
            this.loading = false
            this.bookList = []
            this.getDetailBook(this.detail.ID)
        },
        handleError(e){
            if(this.params.type  ==='eBook'){
                e.target.src = `${this.imageDomainNew}images/default1.png`
            }else if(this.params.type  ==='audioBook'){
                e.target.src = `${this.imageDomainNew}images/default2.png`
            }else if(this.params.type  ==='course'){
                e.target.src = `${this.imageDomainNew}images/default2.png`
            }
        },
        async getDetailBook(id ,val){
            if (this.loading || this.noMore) return;
            this.loading = true
            const res = await api.fetchLeisureDetailBook(this.id, this.params)
            if(res.status) {
                this.loading = false
                this.bookList = [...this.bookList, ...res.data.data.hits]
                this.total = res.data.data.total
                this.noMore = this.bookList.length >= this.total;
                if (this.bookList.length >= this.total || this.total < this.params.pageSize) {
                    this.finished = true
                }
            }
        },
        // 1. 获取父组件的滚动容器DOM
        getParentScrollContainer() {
            this.scrollContainer = this.$parent.$refs[this.parentScrollRef];
            if (!this.scrollContainer) {
                console.error('未找到父组件滚动容器，请检查ref或选择器');
                return;
            }
            // 监听父容器的滚动事件
            this.scrollContainer.addEventListener('scroll', this.handleParentScroll);
        },
        handleParentScroll() {
            // 防抖：300ms内只执行一次，避免频繁触发
            clearTimeout(this.scrollDebounce);
            this.scrollDebounce = setTimeout(() => {
                this.checkParentScrollBottom();
            }, 300);
        },
        checkParentScrollBottom() {
            if (!this.scrollContainer) return;
            const { scrollTop, clientHeight, scrollHeight } = this.scrollContainer;
            const threshold = 100;  // 距离底部200px时触发加载
            // 滚动到底部条件：当前滚动位置 + 容器高度 + 阈值 >= 内容总高度
            const isNearBottom = scrollTop + clientHeight + threshold >= scrollHeight;

            // 满足条件且非加载中、有更多数据，触发加载
            if (isNearBottom && !this.loading  && !this.noMore) {
                this.params.pageIndex ++
                this.getDetailBook(this.id)
            }
        },
        //跳转·详情
        setupBackRouterPath(item){
            if(item.indexType==='Book'){
                this.$router.push({
                    path: '/ebookdtl',
                    query: {
                        id: item.source.sourceBookInfoID,
                        token:this.token
                    }
                })
            }else if(item.indexType==='AudioBook'){
                this.$router.push({
                    path: '/Audtl',
                    query: {
                        id: item.source.sourceID,
                        token:this.token
                    }
                })
            }else if(item.indexType==='Course'){
                this.$router.push({
                    path: '/couraudio',
                    query: {
                        id: item.source.sourceID,
                        token:this.token
                    }
                })
            }
            
        },
        // 投票
        async vote(item, val) {
            const res = await api.fetchLeisureVote({ID: item.ID, field: val})
            if(res.status) {
                this.getDetail(this.id)
            }else{
                this.$message.error(res.message);
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.idle-flip-book-details {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0;
    background: #f7f7f7;
    position: relative;

    .router-container{
        display: flex;
        gap: 10px;
        margin: 16px 0;
        font-size: 12px;
        color: #666;
        .router-item{
            cursor: pointer;
            color: #666;
        }
    }

    .main-content {
        .question-section {
            margin-bottom: 32px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            background: linear-gradient(180deg, #FDF3F3 0%, #fff 100%);
            border-radius: 12px;
            padding: 20px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
            transition: transform 0.2s ease;

            .question-header {
                margin-bottom: 20px;

                .question-title {
                    font-size: 20px;
                    font-weight: bold;
                    color: #333;
                    margin-bottom: 12px;
                    line-height: 1.4;
                    height: 2.8em;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                }

                .question-meta {
                    display: flex;
                    align-items: center;
                    gap: 16px;
                    font-size: 14px;
                    color: #666;

                    .issue-info {
                        color: #999;
                    }

                    .participants {
                        color: #666;
                    }
                }
            }

            .vote-buttons {
                display: flex;
                gap: 16px;

                .vote-btn {
                    padding: 12px 24px;
                    border: none;
                    font-size: 16px;
                    font-weight: 500;
                    cursor: pointer;
                    transition: all 0.3s ease;

                    &.vote-btn-purple {
                        background: #747FEB;
                        border-radius: 8px 0px 8px 8px;
                        color: white;


                        &:hover {
                            transform: scale(1.05);
                        }
                    }

                    &.vote-btn-red {
                        background: #D72A1E;
                        border-radius: 8px 8px 8px 0px;
                        color: white;

                        &:hover {
                            transform: scale(1.05);
                        }
                    }
                }
            }

            .vote-results {
                width: 40%;
                margin-top: 10px;
                .result-item {
                    margin-bottom: 12px;

                    .result-item-left{
                        font-size: 12px;
                        color: #666;
                        display: flex;
                        justify-content: space-between;
                        margin-bottom: 4px;

                        .result-item-info{
                            flex: 1;
                        }
                    }
                    
                }

            }
        }

        .recommendation-section {
            margin-bottom: 24px;

            .section-title {
                font-size: 20px;
                font-weight: bold;
                color: #333;
                margin-bottom: 16px;
            }

            .content-tabs {
                display: flex;
                gap: 20px;

                .tab-btn {
                    padding: 8px 24px;
                    border: none;
                    background: none;
                    font-size: 16px;
                    color: #666;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    background: #E6E6E6;
                    border-radius: 20px;

                    &.tab-active {
                        color: #fff;
                        background: #D72A1E;
                    }

                    &:hover {
                        transform: scale(1.05);
                    }
                }
            }
        }

        .books-grid {
            display: grid;
            grid-template-columns: repeat(6, 1fr);
            gap: 20px;
            position: relative;

            .book-item {
                display: flex;
                flex-direction: column;
                background: #fff;
                border-radius: 8px;
                cursor: pointer;

                .book-cover {
                    border-radius: 8px 8px 0px 0px;
                    overflow: hidden;
                    min-height: 220px;
                    max-height: 220px;
                    img {
                        width: 100%;
                        object-fit: cover;
                    }
                }

                .book-info {
                    padding: 15px;

                    .book-title {
                        font-size: 14px;
                        font-weight: 500;
                        color: #333;
                        margin-bottom: 4px;
                        line-height: 1.3;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        overflow: hidden;
                    }

                    .book-author {
                        font-size: 12px;
                        color: #666;
                        margin: 0;
                    }
                }
            }
        }
    }
}
.no-data{
    color: #aeaeae;
    position: absolute;
    top:10%;
    left:50%
}
// 无更多数据样式
.no-more {
    padding: 15px;
    text-align: center;
    color: #aeaeae;
    font-size: 14px;
    position: absolute;
    bottom:-7px;
    left:50%
}
</style>
